module.exports = __webpack_public_path__ + "img/x.9c0968fe.svg";